import { BOTTOM_LINE_NAME } from '../../_constants';

export const getBottomLine = (
  parentElement: HTMLElement,
): HTMLElement | null => {
  const children = Array.from(parentElement.children) as Array<HTMLElement>;

  return (
    children.find(
      (child: HTMLElement) =>
        child.dataset.name && child.dataset.name.includes(BOTTOM_LINE_NAME),
    ) || null
  );
};
